import { render, staticRenderFns } from "./Group-Move-File.vue?vue&type=template&id=d855e9e4&"
import script from "./Group-Move-File.vue?vue&type=script&lang=js&"
export * from "./Group-Move-File.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports